import { AlertVariant } from "@fableous/core/model/Enums";
import { EventEmitter } from "../util/EventEmitter";
import { ReactNode } from "react";

type Events = {
    "error": unknown,
    "info": UserMessage,
    "status": ReactNode
}

export const GlobalEventEmitter = new EventEmitter<Events>();

export type UserMessage = {
    title : string,
    variant? : AlertVariant,
    body: string, buttonText : string,
    cancelButtonText? : string
    cancelCallback?: () => void,
    callback?: () => void,
}
/**Not currently in use */
/**export type UserMessageModal = UserMessage & {
    component: FC<unknown>,
    [key : string] : object
};**/